import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useNavigate, useLocation } from 'react-router-dom'
import { sectorImages } from '../../constants/images';
import SaveConfirmModal from '../modals/SaveConfirmModal';
import { isAuthenticated } from '../../services/authService';
import ShareButton from '../common/ShareButton';
import '../../styles/layout/header.css';

const Header = ({ 
  menuItems, 
  isEditing = false, 
  onSave = null 
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  useEffect(() => {
    // console.log('Header received isEditing:', isEditing); // 이 로그 제거
  }, [isEditing]);

  const handleNavigation = useCallback((target, menuText) => {
    console.log(`네비게이션 클릭: ${menuText}, 타겟: ${target}`);
    if (isEditing) {
      setShowSaveModal(true);
      setPendingNavigation({ target, menuText });
      return;
    }
    executeNavigation(target, menuText);
  }, [isEditing]);

  const executeNavigation = useCallback((target, menuText) => {
    // Apply 메뉴 클릭 시 특별 처리
    if (menuText === 'APPLY') {
      const isUserAuthenticated = isAuthenticated();
      if (location.pathname === '/apply' && isUserAuthenticated) {
        setIsMenuOpen(false);
        return;
      }
      navigate('/apply');
      setIsMenuOpen(false);
      return;
    }

    // 직접 클릭했음을 표시 (페이지 로드가 아닌 사용자 액션임을 확인)
    sessionStorage.setItem('userInitiatedScroll', 'true');

    // 다른 메뉴 클릭 시 기존 동작 유지
    if (location.pathname !== '/') {
      // 현재 경로가 메인 페이지가 아닌 경우, 메인 페이지로 이동 후 스크롤
      console.log(`다른 페이지에서 메인으로 이동, 대상: ${target}`);
      navigate('/', { state: { scrollTarget: target } });
    } else {
      // 현재 경로가 메인 페이지인 경우, 바로 스크롤
      console.log(`메인 페이지에서 스크롤, 대상: ${target}`);
      const element = document.querySelector(target);
      if (element) {
        setTimeout(() => {
          // 요소 위치 계산 - 다양한 방법으로 시도
          const offsetTop = element.offsetTop;
          const rect = element.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const absoluteTop = rect.top + scrollTop;
          
          // 헤더 높이 계산
          const headerHeight = document.querySelector('.main_hd')?.offsetHeight || 80;
          
          console.log(`스크롤 계산 값들: offsetTop=${offsetTop}, rect.top=${rect.top}, scrollTop=${scrollTop}, absoluteTop=${absoluteTop}`);
          
          // 스크롤 이동 (offsetTop 사용)
          window.scrollTo({
            top: offsetTop - headerHeight,
            behavior: 'smooth'
          });
        }, 200);
      } else {
        console.warn(`Element with selector "${target}" not found`);
      }
    }
    setIsMenuOpen(false);
  }, [location.pathname, navigate]);

  const handleSaveConfirm = useCallback(async () => {
    if (onSave) {
      await onSave();
    }
    setShowSaveModal(false);
    if (pendingNavigation) {
      executeNavigation(pendingNavigation.target, pendingNavigation.menuText);
      setPendingNavigation(null);
    }
  }, [onSave, pendingNavigation, executeNavigation]);

  const handleSaveCancel = useCallback(() => {
    setShowSaveModal(false);
    setPendingNavigation(null);
  }, []);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(!isMenuOpen);
  }, [isMenuOpen]);

  return (
    <>
      <header className={`main_hd ${isMenuOpen ? 'menu-open' : ''}`}>
        <div className="d-flex">
          <h1 className="logo">
            <a onClick={() => handleNavigation(menuItems.main.target, menuItems.main.text)} className="pointer">
              <img src={sectorImages.logos.main} alt="KSGC" />
            </a>
          </h1>
          
          <nav className="hd_nav">
            <ul className="menu_list">
              {Object.values(menuItems).map((item, index) => (
                <li key={index} className="menu">
                  <a 
                    className="pd-nl pointer" 
                    onClick={() => handleNavigation(item.target, item.text)}
                  >
                    {item.text}
                  </a>
                </li>
              ))}
              {/* <li className="menu share-menu">
                <ShareButton className="header-share-button" />
              </li> */}
            </ul>
          </nav>

          <button 
            className="hamburger-button"
            onClick={toggleMenu}
            aria-label="메뉴 열기"
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>
      <SaveConfirmModal 
        isOpen={showSaveModal}
        onConfirm={handleSaveConfirm}
        onCancel={handleSaveCancel}
      />
    </>
  )
}

Header.propTypes = {
  menuItems: PropTypes.objectOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired
    })
  ).isRequired,
  isEditing: PropTypes.bool,
  onSave: PropTypes.func
};

export default Header 